export default "__VITE_ASSET__DzYdwzzH__"